import React from 'react';
import ReactDOM from 'react-dom/client';
import WrappedApp from './App';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min'; // For Bootstrap's JavaScript functionality
import './index.css';

if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
    // Add this polyfill at the entry point of your application
    if (typeof Promise.withResolvers !== 'function') {
       Promise.withResolvers = function() {
           let resolve, reject;
           const promise = new Promise((res, rej) => {
               resolve = res;
               reject = rej;
           });
           return { promise, resolve, reject };
       };
    }

    // Now you can use the original syntax safely
    const { promise, resolve, reject } = Promise.withResolvers();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <WrappedApp />
    </BrowserRouter>
);
if (!window.matchMedia('(display-mode: standalone)').matches && window.location.hostname !== 'localhost') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(reg => console.log('SW registered', reg.scope))
        .catch(err => console.log('SW registration failed', err));
    });
  }

}

navigator.serviceWorker.addEventListener('controllerchange', () => {
  console.log('Service Worker controller has changed.');
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ action: 'skipWaiting' });
  }
});

